(() => {
  const root = () => window.Shopify?.routes?.root || '/';
  const route = (path) => `${root()}${path}`.replace(/\/{2,}/g, '/');
  const verified = new WeakSet();

  const clearSession = async () => {
    try {
      await fetch(route('cart/update.js'), {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: { _livia_meta_session: '' } }),
      });
    } catch (_error) {
      // Checkout remains Shopify-native even if cleanup is temporarily unavailable.
    }
  };

  const showStandardCheckout = async (summary, shouldClear = true) => {
    summary.querySelector('[data-meta-standard-checkout]')?.removeAttribute('hidden');
    summary.querySelector('[data-meta-verifying]')?.setAttribute('hidden', '');
    summary.querySelector('[data-meta-etsy]')?.setAttribute('hidden', '');
    if (shouldClear) await clearSession();
  };

  const validateSummary = async (summary) => {
    if (verified.has(summary)) return;
    verified.add(summary);
    const token = summary.dataset.metaToken || '';
    const cart = summary.dataset.metaCart || '';
    if (!token || !cart) return showStandardCheckout(summary);

    try {
      const query = new URLSearchParams({ token, cart });
      const response = await fetch(`${route('apps/meta-checkout/validate')}?${query}`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store',
      });
      if (!response.ok) throw new Error('validation');
      const result = await response.json();
      if (!result.valid || !result.etsy_mode || !result.etsy_url) {
        return showStandardCheckout(summary);
      }

      const etsy = summary.querySelector('[data-meta-etsy]');
      const etsyButton = summary.querySelector('[data-meta-etsy-checkout]');
      summary.querySelector('[data-meta-verifying]')?.setAttribute('hidden', '');
      summary.querySelector('[data-meta-standard-checkout]')?.setAttribute('hidden', '');
      etsy?.removeAttribute('hidden');
      etsyButton?.addEventListener('click', async () => {
        etsyButton.disabled = true;
        await clearSession();
        window.location.assign(result.etsy_url);
      }, { once: true });
    } catch (_error) {
      await showStandardCheckout(summary);
    }
  };

  const validateAll = () => {
    document.querySelectorAll('[data-meta-cart-summary]').forEach(validateSummary);
  };

  document.addEventListener('DOMContentLoaded', validateAll);
  document.addEventListener('livia:cart:updated', validateAll);
})();
